import React from 'react';
import { Route, IndexRoute } from 'react-router';
import employee from './screens/List/screens/Employee/router';
import department from './screens/List/screens/Department/router';
import underDepartment from './screens/List/screens/UnderDepartment/router';
export default (
  <Route
    path="peoplesearch"
  >
    <IndexRoute
      getComponent={(Location, callback) => {
        require.ensure([], (require) => {
          callback(null, require('./index'));
        });
      }}
    />
    {underDepartment}
    {department}
    {employee}
  </Route>
);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/PeopleSearch/router.js
 **/